import './BundlesEmptyOrPaywallCard.scss';

import { IonButton, IonCard, IonCardContent, IonIcon, IonLabel } from '@ionic/react';
import { arrowDownCircle } from 'ionicons/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import WhiteBundleIcon from '../../assets/icons/bundle-outline-white.svg';
import LockedBundleIcon from '../../assets/images/img-bundles-locked.svg';
import { BundleMessages } from '../../intl/BundleMessages';
import { DqText } from '../dq-text';

export interface FilterBundleProfiles {
  organizationId: string | undefined;
  siteName: string | undefined;
}

interface BundlesEmptyOrPaywallCardProps {
  bundlesCount?: number;
  validPaidLicense: boolean;
  handleDownload: () => void;
  searchText?: string;
  filterOptions?: FilterBundleProfiles;
}

export const BundlesEmptyOrPaywallCard: React.FC<BundlesEmptyOrPaywallCardProps> = ({
  validPaidLicense,
  handleDownload,
  bundlesCount,
  searchText,
  filterOptions,
}) => {
  return (
    <div className="empty-or-premium-feature-card-scroll-container ion-padding-top">
      {searchText || filterOptions?.siteName || filterOptions?.organizationId ? (
        <div className="search-message">
          <DqText variant="h3">
            <DqText>
              <FormattedMessage {...BundleMessages.noBundlesFoundMessage} />
            </DqText>
          </DqText>
        </div>
      ) : (
        <IonCard className="empty-or-premium-feature-card">
          <IonCardContent className="empty-or-premium-feature-card-content">
            <div className="empty-or-premium-bundle-card-content">
              <IonIcon
                className="empty-or-premium-bundle-icon"
                md={validPaidLicense && bundlesCount === 0 ? WhiteBundleIcon : LockedBundleIcon}
                color="dark"
              />
              <div className="empty-or-premium-content-body">
                {validPaidLicense && bundlesCount === 0 ? (
                  <DqText>
                    <FormattedMessage {...BundleMessages.bundleProfilesTableEmptyResults} />
                  </DqText>
                ) : (
                  <>
                    <DqText>
                      <FormattedMessage {...BundleMessages.bundlePremiumFeature} />
                    </DqText>
                    <div>
                      <a
                        href="https://www.stoneagetools.com/support"
                        className="button button-outline button-positive"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FormattedMessage {...BundleMessages.bundleContactStoneAge} />
                      </a>
                    </div>
                  </>
                )}
                <div className="download-bundle-template-button">
                  <IonButton onClick={handleDownload} color="primary" fill="clear">
                    <IonIcon slot="start" icon={arrowDownCircle} />
                    <IonLabel>
                      <FormattedMessage {...BundleMessages.downloadTemplateButtonLabel} />
                    </IonLabel>
                  </IonButton>
                </div>
              </div>
            </div>
          </IonCardContent>
        </IonCard>
      )}
    </div>
  );
};
